import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, RequireAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import ProjectPage from "@/pages/ProjectPage";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import BusinessInfo from "@/pages/admin/BusinessInfo";
import ContentPage from "@/pages/admin/ContentPage";
import ProjectsPage from "@/pages/admin/ProjectsPage";
import ProjectEditPage from "@/pages/admin/ProjectEditPage";
import ReviewsPage from "@/pages/admin/ReviewsPage";
import AccountPage from "@/pages/admin/AccountPage";
import MessagesPage from "@/pages/admin/MessagesPage";
import MessageDetailPage from "@/pages/admin/MessageDetailPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import AppointmentsPage from "@/pages/admin/AppointmentsPage";
import AppointmentFormPage from "@/pages/admin/AppointmentFormPage";
import FlyersPage from "@/pages/admin/FlyersPage";
import ReviewPage from "@/pages/ReviewPage";

const guard = (el) => <RequireAuth>{el}</RequireAuth>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/work/:projectId" element={<ProjectPage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={guard(<Dashboard />)} />
          <Route path="/admin/business" element={guard(<BusinessInfo />)} />
          <Route path="/admin/content" element={guard(<ContentPage />)} />
          <Route path="/admin/projects" element={guard(<ProjectsPage />)} />
          <Route path="/admin/projects/:projectId" element={guard(<ProjectEditPage />)} />
          <Route path="/admin/reviews" element={guard(<ReviewsPage />)} />
          <Route path="/admin/account" element={guard(<AccountPage />)} />
          <Route path="/admin/messages" element={guard(<MessagesPage />)} />
          <Route path="/admin/messages/:messageId" element={guard(<MessageDetailPage />)} />
          <Route path="/admin/settings" element={guard(<SettingsPage />)} />
          <Route path="/admin/appointments" element={guard(<AppointmentsPage />)} />
          <Route path="/admin/appointments/new" element={guard(<AppointmentFormPage />)} />
          <Route path="/admin/appointments/:appointmentId" element={guard(<AppointmentFormPage />)} />
          <Route path="/admin/flyers" element={guard(<FlyersPage />)} />
          <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
